(function(){
  'use strict';
  var input = document.getElementById('hdr-search-input');
  var results = document.getElementById('bv-instant-results');
  if (!input || !results) return;

  var timer, current = -1;

  function hide(){
    results.classList.add('hidden');
    results.innerHTML = '';
    current = -1;
  }

  function show(products){
    if (!products.length){ hide(); return; }
    results.innerHTML = '';
    results.classList.remove('hidden');
    products.forEach(function(p, i){
      var price = p.price ? (parseFloat(p.price) / 100).toFixed(2).replace('.', ',') + ' ₺' : '';
      var img = p.image
        ? '<img src="' + p.image.replace(/_(pico|icon|thumb|small)\./, '_80x.') + '" alt="" class="w-11 h-11 rounded-lg object-contain bg-surface-container-lowest shrink-0 p-0.5">'
        : '<div class="w-11 h-11 rounded-lg bg-surface-container-lowest shrink-0"></div>';
      var el = document.createElement('a');
      el.href = p.url || '/products/' + p.handle;
      el.className = 'bv-isr-item flex items-center gap-3 px-4 py-2.5 hover:bg-surface-container-low transition-colors';
      el.dataset.index = i;
      el.innerHTML = img
        + '<div class="min-w-0 flex-1"><p class="text-sm font-semibold text-on-surface line-clamp-1">' + p.title + '</p>'
        + (p.vendor ? '<p class="text-[10px] text-tertiary uppercase font-bold">' + p.vendor + '</p>' : '')
        + '</div><span class="text-sm font-extrabold text-primary shrink-0">' + price + '</span>';
      el.addEventListener('mousedown', function(e){ e.preventDefault(); window.location.href = el.href; });
      results.appendChild(el);
    });
    // "Tüm sonuçlar" footer
    var footer = document.createElement('a');
    footer.href = '/search?q=' + encodeURIComponent(input.value) + '&type=product';
    footer.className = 'flex items-center justify-center gap-1.5 py-2.5 text-xs font-bold text-primary border-t border-outline-variant/20 hover:bg-surface-container-low transition-colors';
    footer.innerHTML = '<span class="material-symbols-outlined text-sm">search</span> Tüm sonuçları gör';
    footer.addEventListener('mousedown', function(e){ e.preventDefault(); window.location.href = footer.href; });
    results.appendChild(footer);
  }

  function sade(t){
    return (t || '').replace(/İ/g, 'i').replace(/I/g, 'i').toLowerCase().replace(/ı/g, 'i')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function parcala(t){ return sade(t).split(/[^a-z0-9]+/).filter(Boolean); }

  function search(q){
    if (!q || q.length < 2){ hide(); return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product&resources[limit]=10&resources[fields]=title,price,image,handle,vendor',
      { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        // Aranan her kelime adında/markasında/tipinde/etiketinde bir kelimenin başı olarak geçen
        // ürünler varsa yalnız onlar ("ocean plus" yazınca diğer Ocean ürünleri gelmesin);
        // yoksa Shopify'ın sonuçları olduğu gibi. Arama sayfasıyla aynı kural.
        var kelimeler = parcala(q);
        var tutan = prods.filter(function(p){
          var ad = parcala([p.title, p.vendor, p.type].concat(p.tags || []).join(' '));
          return kelimeler.every(function(w){ return ad.some(function(x){ return x.indexOf(w) === 0; }); });
        });
        show((kelimeler.length && tutan.length ? tutan : prods).slice(0, 6));
      })
      .catch(hide);
  }

  input.addEventListener('input', function(){
    clearTimeout(timer);
    timer = setTimeout(function(){ search(input.value.trim()); }, 220);
  });

  input.addEventListener('keydown', function(e){
    var items = results.querySelectorAll('.bv-isr-item');
    if (e.key === 'ArrowDown'){ e.preventDefault(); current = Math.min(current + 1, items.length - 1); items.forEach(function(el, i){ el.classList.toggle('bg-surface-container-low', i === current); }); }
    else if (e.key === 'ArrowUp'){ e.preventDefault(); current = Math.max(current - 1, -1); items.forEach(function(el, i){ el.classList.toggle('bg-surface-container-low', i === current); }); }
    else if (e.key === 'Enter' && current >= 0 && items[current]){ e.preventDefault(); window.location.href = items[current].href; }
    else if (e.key === 'Escape'){ hide(); input.blur(); }
  });

  input.addEventListener('focus', function(){
    if (input.value.trim().length >= 2) search(input.value.trim());
  });

  document.addEventListener('click', function(e){
    if (!results.contains(e.target) && e.target !== input) hide();
  });
})();
